import styled from 'styled-components';
const HOME_CONTENT_PADDING = '10%';
export const KanbanWrapper = styled.div `
  overflow: scroll;
  padding-left: calc(${HOME_CONTENT_PADDING} / 2);
`;
